let options = {}

function config (_options) {
  if (_options) {
    Object.assign(options, _options)
  }
}

config.current = options

export default config


// WEBPACK FOOTER //
// ./src/wbap-unit-app/wbap-dashboard-dailyPrice/config.js